import { GetListPublicParamsType } from '../../types/common/commonTypes';
import { HolyDayType } from '../../types/holiday/types';
import axios from '../axiosCall'
import Urls from "../endpoints";


export const addHolidays = (params: HolyDayType[]) => {
    return axios.post(Urls.addHolidays(), [...params])
}

export const getHolidays = (params: GetListPublicParamsType) => {
    return axios.post(Urls.getHolidays(), params)
}

export const updateHolidays = (params: HolyDayType[]) => {
    return axios.post(Urls.updateHolidays(), [...params])
}

export const deleteHolidays = (params: string[]) => {
    return axios.post(Urls.deleteHolidays(), params)
}